import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTextShort(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M20 9H4v2h16V9Zm-6 4H4v2h10v-2Z" fill="currentColor" />
    </BaseIcon>
  );
}
